import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const AddMembersBox = styled(Box, { label: 'AddMembersBox' })(({ theme }) => ({
  padding: theme.spacing(0.5, 2, 1.5),
}));
